import React from 'react';
import {
    Home, BookOutlined, RowingOutlined,
    RestaurantOutlined, ImageSearchOutlined,
    EditLocationOutlined, AddToHomeScreenOutlined, ShortTextOutlined, SettingsOutlined,
    AssessmentOutlined, SupervisedUserCircleOutlined, CalendarToday, BuildOutlined, AttachMoney, Wifi, LocalAtmOutlined,
    Facebook, LocalShipping, Person,
    SportsFootballOutlined
} from '@material-ui/icons';
import {
    STATIC_TEXT_APP,
} from 'mobx-store/storeInterfaces/staticTextInterface';
import classes from './NavigationItems.module.scss';
import {
    images,
} from '../../../assets/image';

export const ROLES = {
    ADMIN: 'Admin',
    USER: 'User',
    CUSTOMER_SERVICE: 'customer_service',
    Delivery: 'Delivery',
    SPORTS: 'sports',
    KENYA_ADMIN: 'ADMIN_KENYA',
    OPERATIONS: 'Operations',
    MARKETING: 'marketing',
    FINANCE: 'FINANCE',
    PARTNERSHIP: 'PARTNERSHIP',
    COPYWRITER: 'COPYWRITER',
    SUPER_ADMIN: 'SUPER_ADMIN',
    Rating: 'Rating',
    Wheel: 'Wheel',
    RESTAUANT_ADMIN: 'RESTAURANT',
    LEAD_ADMIN: 'LEAD_ADMIN',
    LEAD_VIEWER: 'LEAD_VIEWER',
    DEV_ADMIN: 'DEV_ADMIN',
    LIVE_SCORING_ADMIN: 'LIVE_SCORING_ADMIN',
    AFCON_ADMIN: 'AFCON_ADMIN'
};

const facilityTypes = {
    MARKETING: 'MARKETING',
    RATING: 'RATING',
    ALL: 'all',
};

export const routesTable = [
    // {
    //   label: 'Home',
    //   icon: <Home color="secondary" />,
    //   allowedUsers: [ROLES.SUPER_ADMIN,  ROLES.DEV_ADMIN,  ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.MARKETING],
    //   children: [
    //     {
    //       label: 'Featured Articles',
    //       path: '/featured-articles',
    //     },
    //     {
    //       label: 'Home Tiles',
    //       path: '/home',
    //     },
    //   ],
    // },
    {
        label: 'Users Management',
        icon: <AssessmentOutlined color="secondary"/>,
        path: '/statistics',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.CUSTOMER_SERVICE],
    },
    {
        label: 'Custom Screens',
        icon: <SupervisedUserCircleOutlined color="secondary"/>,
        path: '/custom-screens',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN],
    },
    {
        label: 'Digital Referals',
        icon: <Person color="secondary" />,
        path: '/leads',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING, ROLES.LEAD_ADMIN, ROLES.LEAD_VIEWER],
    },
    {
        label: 'Wheel of fortune Control',
        icon: <LocalAtmOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.Wheel, ROLES.CUSTOMER_SERVICE],
        children: [
            {
                label: 'Wheel of fortune',
                path: '/wheel-fortune/events',

            },
            {
                label: 'Disabled Members ',

                path: '/no-access-wheel',
            },
        ],
    },
    {
        label: 'News Management',
        icon: <BookOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.MARKETING],
        children: [
            {
                label: 'News Management',
                path: '/news',
            },
            {
                label: 'News Categories Management',
                path: '/news-categories',
            },
        ],
    },
    {
        label: 'Ads Management',
        icon: <AddToHomeScreenOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.MARKETING],
        children: [
            {
                label: 'Banner Ads Management',
                path: '/banner-ads',
            },
            {
                label: 'Notifications Management',
                path: '/notifications',
            },
            {
                label: 'General Ads',
                path: '/general-ads',
            },
        ],
    },
    {
        label: 'Branches Management',
        icon: <EditLocationOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.MARKETING],
        children: [
            {
                label: 'Branches',
                path: '/branches',
            },
            {
                label: ' Branch Facilities Categories',
                path: `/facilities-categories?type=${facilityTypes.MARKETING}`,
            },
            {
                label: 'Branch Facilities',
                path: `/facilities?type=${facilityTypes.MARKETING}`,
            },
            {
                label: 'Branch Gates',
                path: '/gates',
            },
            {
                label: 'Branch Features',
                path: '/branch-features',
            },
        ],
    },
    {
        label: 'Academies',
        icon: <RowingOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.MARKETING, ROLES.SPORTS],
        children: [
            {
                label: 'Management',
                path: '/academies',
            },
            {
                label: 'Announcement',
                path: '/academies-announcements',
            },
        ],
    },
    {
        label: 'Restaurants Management',
        icon: <RestaurantOutlined color="secondary"/>,
        path: '/restaurants',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.RESTAUANT_ADMIN],
    },
    {
        label: 'Gallery Management',
        icon: <ImageSearchOutlined color="secondary"/>,
        path: '/gallery',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.MARKETING],
    },
    {
        label: 'Deglawy Family',
        icon: images.deglawy,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING, ROLES.COPYWRITER],
        children: [
            {
                label: 'Content Management',
                path: '/deglawy/contents',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING, ROLES.COPYWRITER],
            },
            {
                label: 'Featured Management',
                path: '/deglawy/featured',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING],
            },
            {
                label: 'Featured Offers Management',
                path: '/deglawy/featuredOffer',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING],
            },
            {
                label: 'Trophy Management',
                path: '/deglawy/trophies',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING],
            },
            {
                label: 'Portal Content Management',
                path: '/deglawy/portal/contents',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING],
            },
            {
                label: 'offers',
                path: '/offers',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING],
            },
        ],
    },
    {
        label: 'Financial',
        icon: <AttachMoney color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.FINANCE, ROLES.CUSTOMER_SERVICE],
        children: [
            {
                label: 'Renewals Transactions',
                path: '/transactions/renewals',
            },
            {
                label: 'Waterfront Transactions',
                path: '/transactions/waterfront',
            },
        ],
    },

    {
        label: 'Cards Delivery Requests',
        icon: <AttachMoney color="secondary"/>,
        path: '/cards-delivery',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.Delivery, ROLES.CUSTOMER_SERVICE],
    },
    {
        label: 'Calender',
        icon: <CalendarToday color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.KENYA_ADMIN],
        children: [
            {
                label: 'Events Categories',
                path: '/events/category',
            },
            {
                label: 'Events Management',
                path: '/events',
            },
            {
                label: 'Calender Separator',
                path: '/events/calender/separator',
            },
        ],
    },
    {
        label: 'Rating Facilities Management',
        icon: <BuildOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.OPERATIONS, ROLES.KENYA_ADMIN, ROLES.Rating],
        children: [
            {
                label: ' Rating Facilities Groups',
                path: `/facility-groups`,
            },
            {
                label: ' Rating Facilities Categories',
                path: `/facilities-categories?type=${facilityTypes.RATING}`,
            },
            {
                label: 'Rating Facilities Areas',
                path: '/facilities-areas',
            },
            // {
            //   label: 'Rating Facilities Forms',
            //   path: '/facilities-form',
            // },
            {
                label: 'Rating Facilities',
                path: `/facilities?type=${facilityTypes.RATING}`,
            },
            {
                label: 'Reports',
                path: '/facilities/reports/branches',
            },
        ],
    },
    {
        label: 'Wifi Packages',
        icon: <ShortTextOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.CUSTOMER_SERVICE],
        children: [
            {
                label: 'Subscriptions',
                path: '/wifi-packages/subscription',
            },
        ],
    },
    {
        label: 'Dashboard Users',
        icon: <SupervisedUserCircleOutlined color="secondary"/>,
        path: '/users',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN],
    },

    {
        label: 'Static Texts Management',
        icon: <ShortTextOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.COPYWRITER],
        children: [
            {
                label: 'Mobile Static Texts',
                path: `/staticTexts/${STATIC_TEXT_APP.MOBILE}`,
            },
            {
                label: 'Portal Static Texts',
                path: `/staticTexts/${STATIC_TEXT_APP.PORTAL}`,
            },
        ],
    },
    {
        label: 'Settings Management',
        icon: <SettingsOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN, ROLES.CUSTOMER_SERVICE],
        children: [
            {
                label: 'App Settings',
                path: '/settings',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN],
            },
            {
                label: 'CS Working Hours',
                path: '/settings/cs-working-hours',
            },
            {
                label: 'Wifi Services',
                path: '/wifi-packages',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN],
            },
            {
                label: 'Release Notes',
                path: '/release-notes',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN],
            },
        ],
    },
    {
        label: 'Surveys',
        icon: <AssessmentOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.KENYA_ADMIN],
        path: '/survey',
    },
    {
        label: 'Super admin managment',
        icon: <SettingsOutlined color="secondary"/>,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.CUSTOMER_SERVICE],
        children: [
            {
                label: 'User registration',
                path: '/super-managment/registration',
            },
        ]
    },
    {
        label: 'Delivery Regions',
        icon: <LocalShipping color="secondary"/>,
        path: '/delivery-regions',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN],
    },
    {
        label: 'Users\' Facebook Info',
        icon: <Facebook color="secondary"/>,
        path: '/facebook-info',
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.MARKETING],
    },
    {
        label: 'Live Scoring',
        icon: <SportsFootballOutlined color="secondary" />,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.LIVE_SCORING_ADMIN],
        children: [
            {
                label: 'Sports',
                path: '/sports',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.LIVE_SCORING_ADMIN],

            },
            {
                label: 'Tournaments',
                path: '/tournaments',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.LIVE_SCORING_ADMIN],
            },
            {
                label: 'Teams',
                path: '/teams',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.LIVE_SCORING_ADMIN],
            },
            {
                label: 'Matches',
                path: '/matches',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.LIVE_SCORING_ADMIN],
            },
        ],
    },
    {
        label: 'AFCON',
        icon: <SportsFootballOutlined color="secondary" />,
        allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.AFCON_ADMIN],
        children: [
            {
                label: 'Afcon Matches',
                path: '/afcon/matches',
                allowedUsers: [ROLES.SUPER_ADMIN, ROLES.DEV_ADMIN, ROLES.ADMIN, ROLES.AFCON_ADMIN],

            },
        ],
    },
];
